import dynamic from 'next/dynamic'

export const VisitorsChartWithNoSSR = dynamic(() => import('./Visitors'), {
  ssr: false,
})
export const DwellChartWithNoSSR = dynamic(() => import('./Dwell'), {
  ssr: false,
})
export const LoyaltiesChartWithNoSSR = dynamic(() => import('./Loyalties'), {
  ssr: false,
})
export const WeatherChartWithNoSSR = dynamic(() => import('./Weather'), {
  ssr: false,
})
export const AirChartWithNoSSR = dynamic(() => import('./Air'), {
  ssr: false,
})
export const CombinedChartsWithNoSSR = dynamic(() => import('./Combined'), {
  ssr: false,
})
